<template lang="pug">
  div
    .step-content
      slot
      el-form(ref='form' :rules="rules" label-position="top" :model='form')
          el-form-item(label='請選擇您洗衣完成的取件櫃機：' prop="edcode")
            el-button(type="primary" style="width:100%" onclick="if(/line/i.test(navigator.userAgent.toLowerCase())){console.log('line');createOpenLINE('LINE','輸入Order ID');}else{console.log('browser');createOpen('輸入EC ID','輸入Order ID');}document.getElementById('selpm').style.display='block'") 選擇機櫃
          div(style="background-color: rgba(234, 233, 233, 0.72);line-height: 2;display: block;width: 100%;border-radius: 4px;padding: 10px;" id="selpm" ) 您所選擇的機櫃：
            UL
              LI
                input(id="pb_ecmap_code" style="background-color:transparent;border:0;width: 100%;" v-model="form.edcode" value="" disabled)
              LI 櫃機場所：
                input(id="pb_ecmap_name" style="background-color:transparent;border:0;width: 100%;" v-model="form.name" disabled @change="test")
              LI 櫃機地址：
                input(id="pb_ecmap_addr" style="background-color:transparent;border:0;width: 100%;" v-model="form.addr" disabled)
          center
            img(src="@/assets/rule.png" width="100%")
            // spen(id="test" style="display:none;") aaaaaaaaaaaaa
    .cart__footer(class="new-footer")
      el-col(:span="12")
          el-button.white-button(type="success" style="float:left;" @click="goBack") 上一步
      el-col(:span="12")
          el-button.black-button(type="primary" style="float:right;" @click="submit") 下一步
</template>

<script>

export default {
  name: 'CartDetail',
  props: {
    details: {
      type: Object,
      required: true
    },
    shippingMethod: {
      type: Number,
      required: true
    },
    pbEcmap: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      pbEcmap__: {},
      form: {
        edcode: this.pbEcmap.pb_ecmap_code,
        name: this.pbEcmap.pb_ecmap_name,
        addr: this.pbEcmap.pb_ecmap_addr
      },
      rules: {
        edcode: [{ required: true, message: '請選擇還件機櫃', trigger: 'blur' }],
      },
    }
  },
  methods: {
    test() {
      console.log("form.name", this.form.name)
    },
    goBack () {
      this.$router.go(-1)
    },
    submit () {
        // v-modal取不到值
        this.pbEcmap__ = {
            pb_ecmap_code: document.getElementById('pb_ecmap_code').value,
            pb_ecmap_name: document.getElementById('pb_ecmap_name').value,
            pb_ecmap_addr: document.getElementById('pb_ecmap_addr').value,
        }

        
        this.form.edcode = this.pbEcmap__.pb_ecmap_code
        this.form.name = this.pbEcmap__.pb_ecmap_name
        this.form.addr = this.pbEcmap__.pb_ecmap_addr
        // 掌櫃預約驗證
        // this.$refs['form'].validate(valid => {
        //   console.log(valid)
        //   if (!valid) return false
        // })
        console.log(this.pbEcmap)
        if(!document.getElementById('pb_ecmap_code').value || !this.pbEcmap){
          alert("請選擇還件掌櫃櫃機")
          return false
        }
        this.details.edcode = this.form.edcode;

      this.$emit('keyInDetail', this.details)
      this.$emit('setPbEcmap', this.pbEcmap__)
      this.$emit('setStep', 1)
      this.$router.push({ name: 'check' })

      
      
    }
  },
  mounted () {
    this.$emit('setStep', 1)
    this.form.id = this.$store.state.employeeID
    if(this.details){
      console.log("有資料", this.details)
      this.form = this.details;
    }else{
      this.$router.replace({ name: 'info' })
    }
    // document.getElementById('selpm').style.display='block'
    this.form.edcode = this.form.edcode ? this.form.edcode : '未選擇'
    this.form.name = this.form.name ? this.form.name : '未選擇'
    this.form.addr = this.form.addr ? this.form.addr : '未選擇'

  }
}
</script>
 <style lang="scss" scoped >
.cart {
  &__footer {
    // background: white;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    // position: fixed;
    bottom: 0;
    border-top: 1px solid #ccc;
    z-index: 99;
    height: 60px;
    width: 100vw;
    margin-left: -20px;
    margin-bottom: -20px;
    padding: 0 20px;
    .el-button {
      width: 30vw;
    }
  }
}


@media (min-width: 800px) {

 img {
    width: 85%;
    padding: 5px;
  }
  // .cart__footer {
  //   width: 75vw;
  // }
}

// @media (min-width: 1000px) {

//  img {
//     width: 35%;
//     padding: 5px;
//   }
//   .cart__footer {
//     width: 65vw;
//   }
// }
</style>
